module.exports = __webpack_public_path__ + "static/card-clean-trucks-2-3eade14eeaf8fc3f9aaf6f9abe60f762.jpg";